<template>
  <div class="dialog-warp position-relative">
    <h3>访客基础信息：</h3>
    <div class="visitor-tag" :class="{disabled:basicInfo.visitorState === '已过期'}">{{basicInfo.visitorState}}</div>
    <div class="dialog-form">
      <div class="item-content">访客姓名：<p>{{basicInfo.visitorName|empty}}</p></div>
      <div class="item-content">联系方式：<p>{{basicInfo.visitorContract|empty}}</p></div>
      <div class="item-content">身份证号：<p>{{basicInfo.visitorIdcard|empty}}</p></div>
    </div>
    <h3 style="margin-top: 20px;">访客登记信息：</h3>
    <div class="dialog-form">
      <div class="item-content">登记时间：<p>{{basicInfo.createTime|empty}}</p>
      </div>
      <div class="item-content">登记方式：<p><span style="color: #FF0000;">{{basicInfo.visitorRegisterType|empty}}</span></p></div>
      <div class="item-content" style="color: #FF0000;" v-if="basicInfo.visitorRegisterType == '来访登记' || basicInfo.visitorRegisterType == '访客邀请'">邀请人员：<p style="color: #FF0000;">{{basicInfo.createName|empty}}</p></div>
    </div>
    <h3 style="margin-top: 20px;">访客人脸信息：</h3>
    <div class="dialog-form">
      <div class="item-content">人脸图片：
        <div class="img-box"><img :src="basicInfo.facePhotoUrl + '?x-oss-process=image/resize,w_500/auto-orient,1'" alt="" @click.stop="lookBigImg"></div>
      </div>
      <div class="item-content">上传图片时间：<p>{{basicInfo.createTime|empty}}</p></div>
    </div>
    <h3 style="margin-top: 20px;">访客来访信息：</h3>
    <div class="dialog-form">
      <div class="item-content">来访时间：<p>{{basicInfo.visitorStartTime|empty}}</p></div>
      <div class="item-content">来访目的：<p>{{basicInfo.visitorVisitType|empty}}</p></div>
<!--      <div class="item-content">拜访企业：<p>{{basicInfo.companyName|empty}}</p></div>-->
      <!--<div class="item-content">出入楼宇：<p>{{basicInfo.visitorBuilding|empty}}</p></div>
      <div class="item-content">梯控楼层：<p>{{basicInfo.visitorElevator|empty}}</p></div>-->
      <div class="item-content">来访人数：<p>{{basicInfo.visitorNum|empty}}</p></div>
      <div class="item-content">备注：<p>{{basicInfo.visitorRemark|empty}}</p></div>
    </div>
    <div class="text-center" style="margin-top: 20px;justify-content: space-between;">
      <el-button size="mini" type="success" @click="close">完成查看</el-button>
    </div>

    <el-dialog title="查看大图" class="file-big-img append-body" :visible.sync="lookBigImgDialog" top="5%"
               :append-to-body="true" center width="900px">
      <div class="dialog-warp text-center">
        <img :src="imgUrl" alt="图片不见了" class="big-img">
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import * as getData from "../service/getData";
  import * as global from "../config/mUtils";

  export default {
    data() {
      return {
        // basicInfo: {
        //   visitorName: "张三",
        //   phone: 15757101234,
        //   card: 330125196712281867,
        //   facePictures: "",
        //   uploadTime: "2019-04-19  12:12:12",
        //   registerTime: "2019-04-19 12:12:12",
        //   registerType: 1,
        //   VisitingTime: "2019-04-19",
        //   visitPurpose: "参观",
        //   companyName: "园区",
        //   entryExitBuild: "全部",
        //   stairsControlFloor: "全部",
        //   remark: "",
        //   visitorState: ''
        // },
        lookBigImgDialog: false,
        imgUrl: '',
        visitorRecordList: [{}, {}, {}, {}, {}, {}]
      };
    },
    created() {
    },
    mounted() {
      this.init();
    },
    props: ['basicInfo'],
    computed: {},
    methods: {
      close() {
        this.$emit("closeDialog");
      },
      init() {
        console.log(this.basicInfo, 77)
      },
      lookBigImg() {
        this.imgUrl = this.basicInfo.facePhotoUrl;
        this.lookBigImgDialog = true;
      }
    },
    components: {},
    watch: {}
  };
</script>
<style scoped lang="scss">
  @import '../assets/css/mixin';

  .position-relative {
    position: relative;
  }

  .item-content {
    font-size: 14px;
    line-height: 32px;
    display: flex;

    > p {
      flex: 1;
      overflow: auto;
      word-break: break-all;
      font-size: 14px;
      line-height: 32px;
    }

    .img-box {
      width: 85px;
      height: 85px;
      border: 1px solid #333;

      > img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .visitor-record {
    max-height: 330px;
    overflow-y: auto;

    .visitor-record-item {
      border: 1px solid #c0c0c0;
      border-top: 0;
      padding: 10px;
      box-sizing: border-box;
      cursor: pointer;

      .content {
        flex: 1;
        width: 100%;
        height: 100%;
        display: flex;

        .content-l {
          width: 60%;
          height: 100%;
        }

        .content-r {
          flex: 1;
          overflow: auto;
          height: 100%;
        }
      }

      .icon-box {
        i {
          font-size: 32px;
          color: #dadada;
        }
      }
    }

    .visitor-record-item:first-child {
      border-top: 1px solid #c0c0c0;
    }
  }

  .visitor-tag {
    position: absolute;
    width: 94px;
    height: 24px;
    background: rgba(22, 155, 213, 1);
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    right: 0px;
    top: 20px;
    font-size: 16px;
    line-height: 24px;
    color: #fff;
    text-align: center;
  }

  .visitor-tag.disabled {
    background: rgba(188, 188, 188, 1);
  }
</style>



// WEBPACK FOOTER //
// src/components/visitor-register-detail.vue